var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"story-wrapper"},[_c('v-row',_vm._l((_vm.images),function(image,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"4","md":"4","lg":"4"}},[_c('AppStoryCard',{attrs:{"image":image,"hoverImage":_vm.hoverImages ? _vm.hoverImages[index] : _vm.hoverImages,"content":_vm.content[index],"shadow":_vm.shadows[index],"withArrow":_vm.withArrows &&
            index < _vm.images.length - 1 &&
            _vm.$vuetify.breakpoint.mdAndUp}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }